"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
const HttpClient_1 = require("../../Components/Http/HttpClient");
const HttpService_1 = require("../../Components/Http/HttpService");
const RequestMethod_1 = require("../../Components/Http/RequestMethod");
const Loader_1 = require("../../Components/Loader/Loader");
const Druid_1 = require("../../Druid");
const EventHandler_1 = require("../../Framework/EventHandler");
const MessageBus_1 = require("../../Framework/Messaging/MessageBus");
const ViewFinder_1 = require("../../Framework/View/ViewFinder");
const Bind_1 = require("../../Utility/Decorator/Bind");
const UrlBuilder_1 = require("../../Utility/UrlBuilder");
class View {
    constructor() {
        var _a, _b;
        this.loader = new Loader_1.default();
        this.httpClient = new HttpClient_1.default(new HttpService_1.default({ link: 'cancel' }));
        this.displayStyle = 'block';
        this.events = new EventHandler_1.default();
        this.subscriptions = [];
        this.mounting = false;
        this.isMounted = false;
        // $target is set from HTMLElement.getView methods
        this.el = (_a = this.constructor.prototype.$target) !== null && _a !== void 0 ? _a : document.createElement('div');
        // $url is set from the Component decorator
        this.url = (_b = this.constructor.prototype.$url) !== null && _b !== void 0 ? _b : undefined;
        this.framework = Druid_1.default.getViewFramework();
        this.framework.registerView(this.el, this);
        this.viewFinder = new ViewFinder_1.default(this.framework);
        delete this.constructor.prototype.$target;
        document.body.addEventListener(Druid_1.default.DISPOSE_EVENT, this.dispose);
    }
    /**
     * Show the current view
     */
    show() {
        this.el.style.display = this.displayStyle;
        return this;
    }
    /**
     * Hide the current view
     */
    hide() {
        this.el.style.display = 'none';
        return this;
    }
    /**
     * Empty given element and set current view as only child
     */
    insertInto(element) {
        element.innerHTML = '';
        element.append(this.el);
        this.events.trigger('connected');
        return this;
    }
    /**
     * Remove the current element from the dom and replace it with the given element
     *
     * @param element the element to replace the view with
     * @param mount if false, the element won't be mounted to the given element
     */
    replaceWith(element, mount = true) {
        this.el.replaceWith(element);
        if (mount) {
            this.unmount();
            const prevElement = this.el;
            this.el = element;
            this.mount();
            // broadcast to page an element and its children have been disposed
            Druid_1.default.dispose(prevElement);
        }
        return this;
    }
    /**
     * Register a component to this view
     */
    register(target) {
        if (this.mounting) {
            throw new Error('Do not call `this.register` inside the `mounted` function. Place `this.register` calls inside the constructor');
        }
        target.setAccessor({
            getElement: () => this.el,
            onConnected: handler => this.events.on('connected', handler),
            onLoadStarted: handler => this.events.on('load.started', handler),
            onLoadFinished: handler => this.events.on('load.finished', handler),
            onMounted: handler => this.events.on('mounted', handler),
            onUnmounted: handler => this.events.on('unmounted', handler)
        });
        return target;
    }
    /**
     * The content of the element will be empty
     */
    setEmpty() {
        this.el.innerHTML = '';
        Druid_1.default.dispose(undefined);
        return this;
    }
    /**
     * Check if the view is currently empty. Eg has no html content at all
     */
    isEmpty() {
        return this.el.innerHTML === '';
    }
    /**
     * Called when the element is set or renewed and events should be mounted. This function will be called multiple times.
     */
    mounted() {
    }
    /**
     * Emit a Message to another View. Overwrite Channel/Subject if you need custom values
     */
    emit(message) {
        return MessageBus_1.default.emit(message);
    }
    /**
     * Listen for all message that match the message class string.
     * Ex:
     *    observe(ActionMessage, () => {});
     *
     * Will listen for all messages of type ActionMessage
     */
    observe(messageConstructor, handler) {
        const subscription = MessageBus_1.default.observe(messageConstructor, handler);
        this.subscriptions.push(subscription);
        return this;
    }
    /**
     * By default, use the @component('url') to set the view url. In certain scenario's if you need to change the default
     * view url, you can change it with this function.
     */
    setUrl(url) {
        this.url = url;
        return this;
    }
    /**
     * Update the current View with new data from the php backend
     * - see @component('<url>') for what url will be used for the request
     * - need to replace any vars in the url? See UpdateOptions.replaceVars
     *
     * @param data the GET request query parameters to pass with the url
     * @param options  Additional update options. See UpdateOptions for more details
     */
    update(data, options) {
        if (this.url === undefined) {
            throw new Error('Component doesn\'t have an url defined. Use @component(\'<url>\') decorator to specify the url.');
        }
        if ((options === null || options === void 0 ? void 0 : options.loader) !== false) {
            this.loader.setElement(this.el).start();
        }
        this.events.trigger('load.started');
        // prepare url
        const url = new UrlBuilder_1.default(this.url).replaceVars(options === null || options === void 0 ? void 0 : options.replaceVars).trimOptional().build();
        // determine request type
        let promise;
        if (data !== undefined && (options === null || options === void 0 ? void 0 : options.method) === RequestMethod_1.default.POST) {
            promise = this.httpClient.post(url, data);
        }
        else {
            promise = this.httpClient.get(url, data);
        }
        // send request and handle response.
        // Wrapped in a new Promise as "finally" will consume the entire request promise
        return new Promise((resolve, reject) => {
            promise
                .then(response => response.text())
                .then((text) => {
                this.setHtml(text, { keepDisplayStyle: (options === null || options === void 0 ? void 0 : options.keepDisplayStyle) === true });
                if ((options === null || options === void 0 ? void 0 : options.show) === true) {
                    this.show();
                }
                resolve();
            })
                .catch(e => reject(e))
                .finally(() => {
                this.events.trigger('load.finished');
                this.loader.stop();
            });
        });
    }
    /**
     * Get a sub-view with the given view class. Example: `this.getView(WarehouseListView);`. Will throw error when the subview can't be found.
     *
     * @param className the class to instantiate
     * @param args Pass any extra arguments to the View
     * @throws Error when view can't be found
     */
    getView(className, ...args) {
        return new ViewFinder_1.default(this.framework).getView(this.el, className, ...args);
    }
    /**
     * Try to get a sub-view that might not exist. The promise will resolve when the view exists or rejected when it doesn't
     *
     * @param className the class to instantiate
     * @param args Pass any extra arguments to the View
     * @throws Error when view can't be found
     */
    getViewPromise(className, ...args) {
        return new ViewFinder_1.default(this.framework).getViewPromise(this.el, className, ...args);
    }
    /**
     * Get a sub-view with the given view class. Example: `this.getView(WarehouseListView);`. Will throw error when the subview can't be found.
     *
     * @param className the class to instantiate
     * @param args Pass any extra arguments to the View
     * @throws Error when view can't be found
     */
    getViewOrNull(className, ...args) {
        return new ViewFinder_1.default(this.framework).getViewOrNull(this.el, className, ...args);
    }
    /**
     * Get all of sub-views for the given class. `this.getViews(WarehouseListView);`
     */
    getViews(className, ...args) {
        return new ViewFinder_1.default(this.framework).getViews(this.el, className, ...args);
    }
    /**
     * Replace the current bound element with the given html. A new element will be assigned
     */
    setHtml(html, options) {
        const element = document.createElement(html);
        // notify current element will be replaced
        this.unmount();
        // replace element
        const prevElement = this.el;
        this.el.replaceWith(element);
        this.el = element;
        if (options.keepDisplayStyle === true) {
            // transfer style.display to new element to maintain the same visibility
            this.el.style.display = prevElement.style.display;
        }
        // broadcast to page an element and its children have been disposed
        Druid_1.default.dispose(prevElement);
        // request to attach events
        this.mount();
        return this;
    }
    /**
     * Mount element to view and notify listeners
     */
    mount() {
        this.framework.registerView(this.el, this);
        this.framework.applyPropertyDecorators(this, this.el);
        this.framework.applyWiredDecorator(this, this.el);
        this.framework.applyFunctionDecorators(this, this.el, this.isMounted);
        this.loader.setElement(this.el);
        this.isMounted = true;
        this.events.trigger('mounted');
        this.mounting = true;
        this.mounted();
        this.mounting = false;
    }
    /**
     * Will be invoked _just_ before the current element will be replaced
     */
    unmount() {
        this.framework.unregisterView(this.el);
        this.events.trigger('unmounted');
    }
    dispose() {
        // this.el is still bound to the page, no dispose required
        if (this.el.closest('body') !== null) {
            return;
        }
        this.framework.unregisterView(this.el);
        this.el.removeEventListeners();
        document.body.removeEventListener(Druid_1.default.DISPOSE_EVENT, this.dispose);
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
        this.subscriptions = [];
    }
}
exports.default = View;
__decorate([
    Bind_1.default
], View.prototype, "dispose", null);
//# sourceMappingURL=View.js.map